"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.genCompactItemVerticalStyle = genCompactItemVerticalStyle;
function compactItemVerticalBorder(token, parentCls) {
  return {
    // border collapse
    ["&-item:not(".concat(parentCls, "-last-item)")]: {
      marginBottom: token.calc(token.lineWidth).mul(-1).equal()
    },
    '&-item': {
      '&:hover,&:focus,&:active': {
        zIndex: 2
      },
      '&[disabled]': {
        zIndex: 0
      }
    }
  };
}
function compactItemBorderVerticalRadius(prefixCls, parentCls) {
  return {
    ["&-item:not(".concat(parentCls, "-first-item):not(").concat(parentCls, "-last-item)")]: {
      borderRadius: 0
    },
    ["&-item".concat(parentCls, "-first-item:not(").concat(parentCls, "-last-item)")]: {
      ["&, &".concat(prefixCls, "-sm, &").concat(prefixCls, "-lg")]: {
        borderEndEndRadius: 0,
        borderEndStartRadius: 0
      }
    },
    ["&-item".concat(parentCls, "-last-item:not(").concat(parentCls, "-first-item)")]: {
      ["&, &".concat(prefixCls, "-sm, &").concat(prefixCls, "-lg")]: {
        borderStartStartRadius: 0,
        borderStartEndRadius: 0
      }
    }
  };
}
function genCompactItemVerticalStyle(token) {
  const compactCls = "".concat(token.componentCls, "-compact-vertical");
  return {
    [compactCls]: Object.assign(Object.assign({}, compactItemVerticalBorder(token, compactCls)), compactItemBorderVerticalRadius(token.componentCls, compactCls))
  };
}